<template>
  <div class="container" fluid>
    <b-modal
      scrollable
      id="editUrlSource"
      @cancel="resetFields"
      @shown="loadData"
      @ok="createUrlSouce"
      size="xl"
      title="Configuraçao XML1"
      v-if="sourceToEdit"
    >
      <div class="isSimple" v-if="isSimple">
        <!-- <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label>Reference:</label>
              </b-col>
              <b-col sm="10">
                <b-form-input
                  size="sm"
                  placeholder="Enter the reference source"
                  v-model="SourceUrl.c_u_ReferenceSource"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label>Status:</label>
              </b-col>
              <b-col sm="10">
                <b-form-select :options="statusOptions" v-model="SourceUrl.c_u_Status"></b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label>Regularity:</label>
              </b-col>
              <b-col sm="6">
                <b-form-select :options="regularityOptions" v-model="SourceUrl.c_u_Regularity"></b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <b-row class="my-1">
              <b-col sm="2">
                <label>Keywords:</label>
              </b-col>
              <b-col sm="10">
                <b-form-input
                  size="sm"
                  placeholder="Enter the Keywords"
                  v-model="SourceUrl.c_u_Keywords"
                  v-on:keyup="semicolonKey"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col>
            <label>URLS</label>
          </b-col>
        </b-row>
        <b-row class="borderStyler">
          <b-col sm="11">
            <div v-for="item of clicked">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>Url:</label>
                </b-col>
                <b-col sm="8">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the url"
                    v-model="urlArray[item - 1].url"
                  ></b-form-input>
                </b-col>
                <b-col sm="2" class="align-self-end">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeUrlDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Priority:</label>
                </b-col>
                <b-col sm="8">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="urlArray[item - 1].priority"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add other url'"
              @click="addUrlDiv(clicked)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <!-- TO EXTRACT BLOCK -->
        <b-row>
          <b-col>
            <label> TO EXTRACT</label>
          </b-col>
        </b-row>
        <b-row class="borderStyler"> </b-row>
        <div v-for="item in addDivPartialUrl" class="borderItem">
          <b-row>
            <b-col>
              <label>Item {{ item }}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label>For:</label>
            </b-col>
            <b-col sm="8">
              <b-form-checkbox-group
                :options="optionsForUrl"
                value-field="item"
                text-field="name"
                v-model="selectedUrlForExtract[item - 1]"
              ></b-form-checkbox-group>
            </b-col>
            <b-col sm="1" class="align-self-end" v-if="item > 1">
              <b-button
                size="sm"
                variant="danger"
                v-b-popover.hover.right="'Eliminar Item'"
                @click="removeItemfromUrl(item - 1)"
              >
                <fa icon="minus" size="sm" />
              </b-button>
            </b-col>
          </b-row>
          <div v-if="addDivNotFullUrl[item - 1]">
            <b-row>
              <b-col sm="11">
                <div
                  v-for="idQuery of addDivToQuery[item - 1]"
                  class="queryBorder"
                >
                  <b-row class="my-1">
                    <b-col sm="2">
                      <label>Query:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-textarea
                        placeholder="Enter the query..."
                        rows="1"
                        id="text-area"
                        v-model="
                          toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                            .query
                        "
                      ></b-form-textarea>
                    </b-col>
                    <b-col sm="1" class="align-self-end" v-if="idQuery > 1">
                      <b-button
                        size="sm"
                        variant="danger"
                        @click="removeQueryOfUrl(item - 1, idQuery - 1)"
                      >
                        <fa icon="minus" size="sm" />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="2">
                      <label>Parcial Url:</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-checkbox
                        v-model="
                          toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                            .isPartial
                        "
                        @change="
                          toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                            .isPartial == false
                            ? (toReplaceOptions[item - 1].queryToReplace[
                                idQuery - 1
                              ].isPartial = true)
                            : (toReplaceOptions[item - 1].queryToReplace[
                                idQuery - 1
                              ].isPartial = false);
                          $forceUpdate();
                        "
                      ></b-form-checkbox>
                    </b-col>
                  </b-row>
                  <div
                    v-if="
                      toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                        .isPartial
                    "
                  >
                    <b-row class="my-1">
                      <b-col sm="2">
                        <label>To Replace:</label>
                      </b-col>
                      <b-col sm="6">
                        <b-form-input
                          size="sm"
                          placeholder="To replace in url query"
                          v-model="
                            toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].toReplace
                          "
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="2">
                        <label>Prepare QS:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-checkbox
                          v-model="
                            toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].prepateQs
                          "
                        ></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
              <b-col sm="1; align-self-center">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  v-b-popover.hover.right="'Add other url'"
                  @click="addQueryForUrl(addDivToQuery[item - 1], item)"
                  v-if="isSimple"
                >
                  <fa icon="plus" size="sm" />
                </b-button>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <label>URL:</label>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  size="sm"
                  placeholder="To replace in url query"
                  v-model="toReplaceOptions[item - 1].urlToReplace"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-button
          variant="outline-primary"
          size="sm"
          v-b-popover.hover.right="'Add other url'"
          @click="addPartialUrlDiv(addDivPartialUrl)"
          v-if="isSimple"
        >
          <fa icon="plus" size="sm" />
        </b-button>
        <b-row>
          <b-col>
            <label> TO REMOVE</label>
          </b-col>
        </b-row>
        <b-row class="borderStyler"> </b-row>
        <div v-for="item in addDivToRemove">
          <b-row>
            <b-col>
              <label>Item {{ item }}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-col sm="12">
                <label>For:</label>
              </b-col>
            </b-col>
            <b-col sm="8">
              <b-form-checkbox-group
                :options="optionsForRemoveUrl"
                value-field="item"
                text-field="name"
                v-model="selectedUrlForRemove[item - 1]"
              ></b-form-checkbox-group>
            </b-col>
            <b-col sm="1" class="align-self-end" v-if="item > 1">
              <b-button
                size="sm"
                variant="danger"
                v-b-popover.hover.right="'Eliminar Item'"
                @click="removeItemOfRemove(item - 1)"
              >
                <fa icon="minus" size="sm" />
              </b-button>
            </b-col>
          </b-row>
          <div v-if="addDivToRemoveQueries[item - 1]">
            <b-row>
              <b-col sm="11">
                <div
                  v-for="id of addDivToQueryOfRemove[item - 1]"
                  class="queryBorder"
                  :key="id"
                >
                  <b-row class="my-1">
                    <b-col sm="3">
                      <b-col sm="2">
                        <label>Query:</label>
                      </b-col>
                    </b-col>
                    <b-col sm="6">
                      <b-form-textarea
                        placeholder="Enter the query..."
                        rows="1"
                        id="text-area"
                        v-model="
                          toRemoveOptions[item - 1].queryToRemove[id - 1].query
                        "
                      ></b-form-textarea>
                    </b-col>
                    <b-col sm="1" class="align-self-end" v-if="id > 1">
                      <b-button
                        size="sm"
                        variant="danger"
                        @click="removeRemoveQueryUrl(item - 1, id - 1)"
                      >
                        <fa icon="minus" size="sm" />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="3">
                      <b-col sm="12">
                        <label>Parcial Url:</label>
                      </b-col>
                    </b-col>
                    <b-col sm="8">
                      <b-form-checkbox
                        @change="
                          toRemoveOptions[item - 1].queryToRemove[id - 1]
                            .isRemoved == false
                            ? (toRemoveOptions[item - 1].queryToRemove[
                                id - 1
                              ].isRemoved = true)
                            : (toRemoveOptions[item - 1].queryToRemove[
                                id - 1
                              ].isRemoved = false);
                          $forceUpdate();
                        "
                      ></b-form-checkbox>
                    </b-col>
                  </b-row>
                  <div
                    v-if="
                      toRemoveOptions[item - 1].queryToRemove[id - 1].isRemoved
                    "
                  >
                    <b-row>
                      <b-col sm="3">
                        <b-col sm="12">
                          <label>To Replace:</label>
                        </b-col>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input
                          size="sm"
                          placeholder="To replace in url query"
                          v-model="
                            toRemoveOptions[item - 1].queryToRemove[id - 1]
                              .toReplace
                          "
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="3">
                        <b-col sm="12">
                          <label>Prepare QS:</label>
                        </b-col>
                      </b-col>
                      <b-col sm="8">
                        <b-form-checkbox
                          v-model="
                            toRemoveOptions[item - 1].queryToRemove[id - 1]
                              .prepateQs
                          "
                        ></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
              <b-col sm="1; align-self-center">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  v-b-popover.hover.right="'Add other url'"
                  @click="
                    addQueryForRemove(addDivToQueryOfRemove[item - 1], item)
                  "
                  v-if="isSimple"
                >
                  <fa icon="plus" size="sm" />
                </b-button>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <b-col sm="12">
                  <label>URL:</label>
                </b-col>
              </b-col>
              <b-col sm="8">
                <b-form-input
                  size="sm"
                  placeholder="To replace in url query"
                  v-model="toRemoveOptions[item - 1].urlToRemove"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row style="margin-top: 5px">
          <b-col sm="11 text-right">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Add new Item'"
              @click="
                addDivForItemToRemove(addDivToRemove);
                toRemoveAddQueries(addDivToRemove);
                $forceUpdate();
              "
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col sm="11 text-center">
            <b-button variant="outline-primary" size="sm" v-b-modal.editSource2>News Configuration</b-button>
          </b-col>
        </b-row> -->
      </div>
      <!--advanced Mode XML1-->
      <div class="isSimple" v-if="isSimple == false">
        <b-row class="my-1">
          <b-col>
            <b-form-textarea
              id="textarea-large"
              rows="12"
              size="sm"
              v-model="advancedXML"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="advancedMode(isSimple)"
        class="advance"
        id="advancedBtn"
        >Advanced Mode</b-button
      >
    </b-modal>
    <!--News Configuration Modal-->
    <b-modal
      scrollable
      id="editSource2"
      @ok="createXml2"
      @show="loadData"
      @cancel="resetFields"
      size="xl"
      title="Configuraçao XML2"
      v-if="sourceToEdit"
    >
      <div class="isSimple2" v-if="isSimple2">
        <b-row>
          <b-col style="text-align: center">
            <label>Title</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivTitle">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="titleArray[item - 1].query"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeTitleDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="titleArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addTitleDiv(addDivTitle)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Resume</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivResume">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="resumeArray[item - 1].query"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeResumeDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="resumeArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addResumeDiv(addDivResume)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Image</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivImage">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="imageArray[item - 1].query"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeImageDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="imageArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row v-if="item > 1">
                <b-col sm="2">
                  <label for="input-small">Partial Url:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-checkbox
                    v-model="imageArray[item - 1].isPartial"
                    value="1"
                    unchecked-value="0"
                    @change="
                      imageArray[item - 1].isPartial == '0'
                        ? (imageArray[item - 1].isPartial = '1')
                        : (imageArray[item - 1].isPartial = '0');
                      $forceUpdate();
                    "
                  ></b-form-checkbox>
                </b-col>
              </b-row>
              <b-row v-if="imageArray[item - 1].isPartial == '1'">
                <b-col sm="2">
                  <label for="input-small">To Replace:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="To replace in url query"
                    v-model="imageArray[item - 1].toReplace"
                  ></b-form-input>
                </b-col>
              </b-row>
            </div>
            <b-row style="margin-bottom: 10px">
              <b-col sm="2">
                <label for="input-small">Url:</label>
              </b-col>
              <b-col sm="9">
                <b-form-input
                  size="sm"
                  placeholder="URL QUERY"
                  v-model="imageArrayUrl"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addImageDiv(addDivImage)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Text</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivText">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="textArray[item - 1].query"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeTextDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="confidenceOptions"
                    v-model="textArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addTextDiv(addDivText)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Remove</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivRemove">
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Reference :</label>
                </b-col>
                <b-col sm="8">
                  <b-form-select
                    :options="removeOptions"
                    v-model="removeArray[item - 1].reference"
                  ></b-form-select>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeRemoveDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <div v-for="idQuery of addQueryToRemove[item - 1]" :key="idQuery">
                <b-row class="my-1">
                  <b-col sm="2">
                    <label>XPATH:</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      size="sm"
                      placeholder="Enter the query"
                      v-model="removeArray[item - 1].queries[idQuery - 1].query"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="1" class="align-self-end" v-if="idQuery > 1">
                    <b-button
                      size="sm"
                      variant="danger"
                      @click="removeRemoveQueries(item - 1, idQuery - 1)"
                    >
                      <fa icon="minus" size="sm" />
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-col>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  v-b-popover.hover.right="'Nova Query'"
                  @click="addRemoveDivQuery(addQueryToRemove[item - 1], item)"
                  v-if="isSimple2"
                >
                  <fa icon="plus" size="sm" />
                </b-button>
              </b-col>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Novo Item'"
              @click="addRemoveDiv(addDivRemove)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <!--Advanced Mode XML2-->
      <div class="isSimple2" v-if="isSimple2 == false">
        <b-row class="my-1">
          <b-col>
            <b-form-textarea
              id="textarea-large"
              rows="25"
              size="sm"
              v-model="advancedXML2"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="advancedMode2(isSimple2)"
        class="advance2"
        >Advanced Mode</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  name: "EditUrl",

  data() {
    return {
      clicked: 0,
      endpoint: "Sources",
      sourceToEdit: [],
      addDivTitle: 1,
      addDivResume: 1,
      addDivImage: 1,
      addDivText: 1,
      addDivRemove: 1,
      addDivPartialUrl: 1,
      addDivNotFullUrl: [false],
      addDivToRemoveQueries: [false],
      addDivToQueryOfRemove: [1],
      addQueryToRemove: [1],
      addDivToQuery: [1],
      addDivToRemove: 1,
      optionsForRemoveUrl: [],
      selectedUrlForRemove: [[]],
      optionsForUrl: [],
      selectedUrlForExtract: [],
      isSimple: true,
      isSimple2: true,
      disabled: true,
      editedConvertedXML1: [],
      editedConvertedXML2: [],
      lo: _,
      document: $(document),
      urlParameters1: "",
      advancedXML: "",
      advancedXML2: "",
      urlArray: [
        {
          url: "",
          priority: 0,
        },
      ],
      toReplaceOptions: [
        {
          toReplace: "",
          queryToReplace: [
            {
              query: "",
              toReplace: "",
              prepateQs: false,
              isPartial: false,
            },
          ],
          urlToReplace: "",
        },
      ],
      toRemoveOptions: [
        {
          queryToRemove: [
            {
              query: "",
              toReplace: "",
              prepateQs: false,
              isRemoved: false,
            },
          ],
          urlToRemove: "",
        },
      ],
      titleArray: [
        {
          query: "",
          confidenceLevel: 0,
        },
      ],
      resumeArray: [
        {
          query: "",
          confidenceLevel: 0,
        },
      ],
      imageArray: [
        {
          query: "",
          confidenceLevel: 0,
          isPartial: 0,
          toReplace: "",
        },
      ],
      imageArrayUrl: "",
      textArray: [
        {
          query: "",
          confidenceLevel: 0,
        },
      ],
      removeArray: [
        {
          reference: 0,
          queries: [{ query: "" }],
        },
      ],
      SourceUrl: {
        c_id: 0,
        c_u_Type: 1,
        c_u_Status: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Keywords: "",
        c_u_Parameters1: "",
        c_u_Parameters2: "",
      },
      priorityOptions: [
        { value: "0", text: "Please select a priority" },
        { value: "30", text: "High" },
        { value: "20", text: "Medium" },
        { value: "10", text: "Low" },
      ],
      statusOptions: [
        { value: "0", text: "Please select a status" },
        { value: "1", text: "Enabled" },
        { value: "2", text: "Disabled" },
      ],
      confidenceOptions: [
        { value: "0", text: "Please select a priority" },
        { value: "30", text: "High" },
        { value: "20", text: "Medium" },
        { value: "10", text: "Low" },
      ],
      regularityOptions: [
        { value: "0", text: "Please select a regularity" },
        { value: "10", text: "10 Minutos" },
        { value: "20", text: "20 Minutos" },
        { value: "30", text: "30 Minutos" },
        { value: "40", text: "40 Minutos" },
        { value: "50", text: "50 Minutos" },
        { value: "60", text: "60 Minutos" },
      ],
      removeOptions: [
        { value: "0", text: "Please select a Reference" },
        { value: "title", text: "Title" },
        { value: "resume", text: "Resume" },
        { value: "image", text: "Image" },
        { value: "text", text: "Text" },
      ],
    };
  },

  props: {
    idSource: Number,
  },

  components: {},
  watch: {
    selectedUrlForExtract(newVal, oldVal) {
      if (newVal[0] != null) {
        if (this.addDivNotFullUrl[this.addDivPartialUrl - 1] == undefined) {
          this.addDivNotFullUrl[this.addDivPartialUrl - 1] = true;
        }
        if (this.addDivNotFullUrl[this.addDivPartialUrl - 1] != undefined) {
          this.addDivNotFullUrl[this.addDivPartialUrl - 1] = true;
        }
        if (newVal[this.addDivPartialUrl - 1].length == 0) {
          this.addDivNotFullUrl[this.addDivPartialUrl - 1] = false;
        }
      }
    },
    selectedUrlForRemove(newVal, oldVal) {
      if (newVal[0] != null) {
        if (this.addDivToRemoveQueries[this.addDivToRemove - 1] == undefined) {
          this.addDivToRemoveQueries[this.addDivToRemove - 1] = true;
        }
        if (this.addDivToRemoveQueries[this.addDivToRemove - 1] != undefined) {
          this.addDivToRemoveQueries[this.addDivToRemove - 1] = true;
        }
        if (newVal[this.addDivToRemove - 1].length == 0) {
          this.addDivToRemoveQueries[this.addDivToRemove - 1] = false;
          this.toRemoveOptions.splice(this.addDivToRemove - 1, 1);
          this.addDivToQueryOfRemove.splice(this.addDivToRemove - 1, 1);
          this.addDivToRemove = this.addDivToRemove - 1;
        }
      }
    },
  },
  methods: {
    async loadData() {
      //clear the data in cache
      (this.addDivTitle = 1),
        (this.addDivResume = 1),
        (this.addDivImage = 1),
        (this.addDivText = 1),
        (this.addDivRemove = 1),
        (this.addQueryToRemove = [1]),
        (this.titleArray = [
          {
            query: "",
            confidenceLevel: 0,
          },
        ]),
        (this.resumeArray = [
          {
            query: "",
            confidenceLevel: 0,
          },
        ]),
        (this.imageArray = [
          {
            query: "",
            confidenceLevel: 0,
            isPartial: 0,
            toReplace: "",
          },
        ]),
        (this.imageArrayUrl = ""),
        (this.textArray = [
          {
            query: "",
            confidenceLevel: 0,
          },
        ]),
        (this.removeArray = [
          {
            reference: 0,
            queries: [{ query: "" }],
          },
        ]);
      // parse xml to json
      this.$api.data.endpoint = this.endpoint;
      this.sourceToEdit = await this.$api.data.findOneById(this.idSource);
      let parseString = require("xml2js").parseString;
      let xml1 = this.sourceToEdit.c_u_Parameters1;
      if (xml1.trim().length == 0) {
        xml1 =
          '<?xml version="1.0" encoding="UTF-8"?><Configuration For="List"><URLs><URL Id="1" Priority="30">https://www.exemplo.pt/</URL></URLs><ToExtract><Item ForURLsId="1"><Queries><Query Id="1" ConfidenceLevel="20" IsURL="true" IsFullURL="true" ToReplace="" PrepareTextForQS="false">//div[@class=\'exemplo\']/a/@href</Query></Queries><URL></URL></Item></ToExtract><ToRemove/></Configuration>';
      }
      let convertedXml = [];
      parseString(xml1, function (err, result) {
        convertedXml.push(result);
      });
      this.editedConvertedXML1 = convertedXml;

      let xml2 = this.sourceToEdit.c_u_Parameters2;
      if (xml2.trim().length == 0) {
        xml2 =
          '<?xml version="1.0" encoding="UTF-8"?><Configuration For="News"><URLs></URLs><ToExtract><Item ForURLsID="" Reference="title"><Queries><Query Id="1" ConfidenceLevel="20" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//title</Query><Query Id="2" ConfidenceLevel="30" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//meta[@property=\'og:title\']/@content</Query></Queries><URL></URL></Item><Item ForURLsID="" Reference="resume"><Queries><Query Id="1" ConfidenceLevel="30" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//meta[@property=\'og:description\']/@content</Query></Queries><URL></URL></Item><Item ForURLsID="" Reference="image"><Queries><Query Id="1" ConfidenceLevel="30" IsURL="true" IsFullURL="true" ToReplace="" PrepareTextForQS="false">//meta[@property=\'og:image\']/@content</Query></Queries><URL></URL></Item><Item ForURLsID="" Reference="text"><Queries><Query Id="1" ConfidenceLevel="10" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">//div[@class=\'exemplo\']/*[self::p]</Query></Queries><URL></URL></Item></ToExtract><ToRemove><Item ForURLsId="" Reference="0"><Queries></Queries></Item></ToRemove></Configuration>';
      }
      let convertedXml2 = [];
      parseString(xml2, function (err, result) {
        convertedXml2.push(result);
      });
      this.editedConvertedXML2 = convertedXml2;

      // this.SourceUrl.c_u_ReferenceSource = this.sourceToEdit.c_u_ReferenceSource;
      // this.SourceUrl.c_u_Status = this.sourceToEdit.c_u_Status;
      // this.SourceUrl.c_u_Keywords = this.sourceToEdit.c_u_Keywords;
      // this.SourceUrl.c_u_Regularity = this.sourceToEdit.c_u_Regularity;
      this.SourceUrl.c_id = this.sourceToEdit.c_id;
      if (this.sourceToEdit.c_u_Type != 3) {
        // parse XML parameters1 to json reference to url
        for (
          var index = 0;
          index < convertedXml[0].Configuration.URLs[0].URL.length;
          index++
        ) {
          if (
            _.findIndex(this.optionsForUrl, function (o) {
              return o.item == index;
            }) === -1
          ) {
            this.optionsForUrl.push({ item: index, name: `URL${index + 1}` }); // creates the checkbox's options with url name
            this.optionsForRemoveUrl.push({
              item: index,
              name: `URL${index + 1}`,
            }); //creates the objects for the options of ToRemove
          }
          if (this.urlArray[index]) {
            this.urlArray[index].url = /\s/g.test(
              convertedXml[0].Configuration.URLs[0].URL[index]._
            )
              ? convertedXml[0].Configuration.URLs[0].URL[index]._.replace(
                  /\s/g,
                  ""
                )
              : convertedXml[0].Configuration.URLs[0].URL[index]._;
            this.urlArray[index].priority =
              convertedXml[0].Configuration.URLs[0].URL[index].$.Priority;
          }
          if (!this.urlArray[index]) {
            this.urlArray.push({
              url: /\s/g.test(
                convertedXml[0].Configuration.URLs[0].URL[index]._
              )
                ? convertedXml[0].Configuration.URLs[0].URL[index]._.replace(
                    /\s/g,
                    ""
                  )
                : convertedXml[0].Configuration.URLs[0].URL[index]._,
              priority:
                convertedXml[0].Configuration.URLs[0].URL[index].$.Priority,
            });
          }
        }
        let arrayOfStringToNumber = [];
        this.addDivPartialUrl =
          convertedXml[0].Configuration.ToExtract[0].Item.length;
        // To open the block of TO EXTRACT
        for (
          var index = 0;
          index < convertedXml[0].Configuration.ToExtract[0].Item.length;
          index++
        ) {
          this.addDivNotFullUrl[index] = true;
          arrayOfStringToNumber.push(
            convertedXml[0].Configuration.ToExtract[0].Item[
              index
            ].$.ForURLsId.split(",")
          );
        }

        // 2º for to add information to the inputs and checkbox's
        for (var index = 0; index < arrayOfStringToNumber.length; index++) {
          this.toReplaceOptions[index] = {
            toReplace: "",
            queryToReplace: [],
            urlToReplace:
              convertedXml[0].Configuration.ToExtract[0].Item[index].URL[0],
          };
          this.selectedUrlForExtract[index] = [];
          for (let i = 0; i < arrayOfStringToNumber[index].length; i++) {
            this.selectedUrlForExtract[index].push(
              parseInt(arrayOfStringToNumber[index][i]) - 1
            );
          }

          this.addDivToQuery[index] =
            convertedXml[0].Configuration.ToExtract[0].Item[
              index
            ].Queries[0].Query.length;
          for (
            let f = 0;
            f <
            convertedXml[0].Configuration.ToExtract[0].Item[index].Queries[0]
              .Query.length;
            f++
          ) {
            this.toReplaceOptions[index].queryToReplace[f] = {
              query:
                convertedXml[0].Configuration.ToExtract[0].Item[index]
                  .Queries[0].Query[f]._,
              toReplace:
                convertedXml[0].Configuration.ToExtract[0].Item[index]
                  .Queries[0].Query[f].$.ToReplace,
              prepateQs:
                convertedXml[0].Configuration.ToExtract[0].Item[index]
                  .Queries[0].Query[f].$.PrepareTextForQS,
              isPartial:
                convertedXml[0].Configuration.ToExtract[0].Item[index]
                  .Queries[0].Query[f].$.ToReplace == ""
                  ? false
                  : true,
            };
          }
        }

        try {
          // items for the toRemove Divs's
          convertedXml[0].Configuration.ToRemove[0] = /[^&crarr;]/.test(
            convertedXml[0].Configuration.ToRemove[0]
          )
            ? ""
            : convertedXml[0].Configuration.ToRemove[0];

          if (
            convertedXml[0].Configuration.ToRemove[0] != "" ||
            convertedXml[0].Configuration.ToRemove[0] != []
          ) {
            let StringToNumberRemove = [];
            this.addDivToRemove =
              convertedXml[0].Configuration.ToRemove[0].Item.length;
            for (
              var index = 0;
              index < convertedXml[0].Configuration.ToRemove[0].Item.length;
              index++
            ) {
              this.addDivToRemoveQueries[index] = true;
              StringToNumberRemove.push(
                convertedXml[0].Configuration.ToRemove[0].Item[
                  index
                ].$.ForURLsId.split(",")
              );
            }
            for (var index = 0; index < StringToNumberRemove.length; index++) {
              this.toRemoveOptions[index] = {
                toReplace: "",
                queryToRemove: [],
                urlToRemove:
                  convertedXml[0].Configuration.ToRemove[0].Item[index].URL[0],
              };
              this.selectedUrlForRemove[index] = [];
              for (let i = 0; i < StringToNumberRemove[index].length; i++) {
                this.selectedUrlForRemove[index].push(
                  parseInt(StringToNumberRemove[index][i]) - 1
                );
              }

              this.addDivToQueryOfRemove[index] =
                convertedXml[0].Configuration.ToRemove[0].Item[
                  index
                ].Queries[0].Query.length;
              for (
                let f = 0;
                f <
                convertedXml[0].Configuration.ToRemove[0].Item[index].Queries[0]
                  .Query.length;
                f++
              ) {
                this.toRemoveOptions[index].queryToRemove[f] = {
                  query:
                    convertedXml[0].Configuration.ToRemove[0].Item[index]
                      .Queries[0].Query[f]._,
                  toReplace:
                    convertedXml[0].Configuration.ToRemove[0].Item[index]
                      .Queries[0].Query[f].$.ToReplace,
                  prepateQs:
                    convertedXml[0].Configuration.ToRemove[0].Item[index]
                      .Queries[0].Query[f].$.prepateQs,
                  isRemoved:
                    convertedXml[0].Configuration.ToRemove[0].Item[index]
                      .Queries[0].Query[f].$.ToReplace == ""
                      ? false
                      : true,
                };
              }
            }
          }
          this.clicked = convertedXml[0].Configuration.URLs[0].URL.length;
        } catch (err) {}
      } else {
        let btn = document.getElementById("advancedBtn");
        if (btn != null) {
          btn.remove();
        }
        this.isSimple = false;
        this.advancedXML = this.sourceToEdit.c_u_Parameters1;
      }
      // parse xml2 to json reference to title
      for (
        var index = 0;
        index <
        convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query
          .length;
        index++
      ) {
        if (this.titleArray[index]) {
          this.titleArray[index].query = /\s/g.test(
            convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0]
              .Query[index]._
          )
            ? convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[
                index
              ]._.replace(/\s/g, " ")
            : convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0]
                .Query[index]._;
          this.titleArray[index].confidenceLevel =
            convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[
              index
            ].$.ConfidenceLevel;
        }
        if (!this.titleArray[index]) {
          this.titleArray.push({
            query: /\s/g.test(
              convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0]
                .Query[index]._
            )
              ? convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query[
                  index
                ]._.replace(/\s/g, " ")
              : convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0]
                  .Query[index]._,
            confidenceLevel:
              convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0]
                .Query[index].$.ConfidenceLevel,
          });
        }
      }
      this.addDivTitle =
        convertedXml2[0].Configuration.ToExtract[0].Item[0].Queries[0].Query.length;

      // parse xml2 to json reference to resume
      for (
        var index = 0;
        index <
        convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query
          .length;
        index++
      ) {
        if (this.resumeArray[index]) {
          this.resumeArray[index].query = /\s/g.test(
            convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0]
              .Query[index]._
          )
            ? convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[
                index
              ]._.replace(/\s/g, " ")
            : convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0]
                .Query[index]._;
          this.resumeArray[index].confidenceLevel =
            convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[
              index
            ].$.ConfidenceLevel;
        }
        if (!this.resumeArray[index]) {
          this.resumeArray.push({
            query: /\s/g.test(
              convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0]
                .Query[index]._
            )
              ? convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query[
                  index
                ]._.replace(/\s/g, " ")
              : convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0]
                  .Query[index]._,
            confidenceLevel:
              convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0]
                .Query[index].$.ConfidenceLevel,
          });
        }
      }
      this.addDivResume =
        convertedXml2[0].Configuration.ToExtract[0].Item[1].Queries[0].Query.length;
      //parse xml2 to json reference to image
      for (
        var index = 0;
        index <
        convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query
          .length;
        index++
      ) {
        if (this.imageArray[index]) {
          this.imageArray[index].query = /\s/g.test(
            convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
              .Query[index]._
          )
            ? convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[
                index
              ]._.replace(/\s/g, " ")
            : convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
                .Query[index]._;
          this.imageArray[index].confidenceLevel =
            convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[
              index
            ].$.ConfidenceLevel;
        }
        if (!this.imageArray[index]) {
          this.imageArray.push({
            toReplace:
              convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
                .Query[index].$.ToReplace != ""
                ? convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
                    .Query[index].$.ToReplace
                : "",
            isPartial:
              convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
                .Query[index].$.ToReplace != ""
                ? "1"
                : "0",
            query: /\s/g.test(
              convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
                .Query[index]._
            )
              ? convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query[
                  index
                ]._.replace(/\s/g, " ")
              : convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
                  .Query[index]._,
            confidenceLevel:
              convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0]
                .Query[index].$.ConfidenceLevel,
          });
        }
      }
      this.imageArrayUrl =
        convertedXml2[0].Configuration.ToExtract[0].Item[2].URL[0];
      this.addDivImage =
        convertedXml2[0].Configuration.ToExtract[0].Item[2].Queries[0].Query.length;

      //parse xml2 to json reference to text
      for (
        var index = 0;
        index <
        convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query
          .length;
        index++
      ) {
        if (this.textArray[index]) {
          this.textArray[index].query = /\s/g.test(
            convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0]
              .Query[index]._
          )
            ? convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[
                index
              ]._.replace(/\s/g, " ")
            : convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0]
                .Query[index]._;
          this.textArray[index].confidenceLevel =
            convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[
              index
            ].$.ConfidenceLevel;
        }
        if (!this.textArray[index]) {
          this.textArray.push({
            query: /\s/g.test(
              convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0]
                .Query[index]._
            )
              ? convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query[
                  index
                ]._.replace(/\s/g, " ")
              : convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0]
                  .Query[index]._,
            confidenceLevel:
              convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0]
                .Query[index].$.ConfidenceLevel,
          });
        }
      }
      this.addDivText =
        convertedXml2[0].Configuration.ToExtract[0].Item[3].Queries[0].Query.length;

      try {
        // parse xml2 to json reference to Remove
        if (convertedXml2[0].Configuration.ToRemove[0]) {
          for (
            var index = 0;
            index < convertedXml2[0].Configuration.ToRemove[0].Item.length;
            index++
          ) {
            if (this.removeArray[index]) {
              this.removeArray[index].reference =
                convertedXml2[0].Configuration.ToRemove[0].Item[
                  index
                ].$.Reference;
              for (
                let i = 0;
                i <
                convertedXml2[0].Configuration.ToRemove[0].Item[index]
                  .Queries[0].Query.length;
                i++
              ) {
                this.removeArray[index].queries.splice(i, 0, {
                  query: /\s/g.test(
                    convertedXml2[0].Configuration.ToRemove[0].Item[index]
                      .Queries[0].Query[i]._
                  )
                    ? convertedXml2[0].Configuration.ToRemove[0].Item[
                        index
                      ].Queries[0].Query[i]._.replace(/\s/g, " ")
                    : convertedXml2[0].Configuration.ToRemove[0].Item[index]
                        .Queries[0].Query[i]._,
                });
                _.remove(this.removeArray[index].queries, function (n) {
                  return n.query == "";
                });
                this.addQueryToRemove[index] =
                  convertedXml2[0].Configuration.ToRemove[0].Item[
                    index
                  ].Queries[0].Query.length;
              }
            }
            if (!this.removeArray[index]) {
              this.removeArray.splice(index, 0, {
                reference:
                  convertedXml2[0].Configuration.ToRemove[0].Item[index].$
                    .Reference,
              });
              for (
                let k = 0;
                k <
                convertedXml2[0].Configuration.ToRemove[0].Item[index]
                  .Queries[0].Query.length;
                k++
              ) {
                this.removeArray[index].queries.splice(k, 0, {
                  query: /\s/g.test(
                    convertedXml2[0].Configuration.ToRemove[0].Item[index]
                      .Queries[0].Query[k]._
                  )
                    ? convertedXml2[0].Configuration.ToRemove[0].Item[
                        index
                      ].Queries[0].Query[k]._.replace(/\s/g, " ")
                    : convertedXml2[0].Configuration.ToRemove[0].Item[index]
                        .Queries[0].Query[k]._,
                });
                _.remove(this.removeArray[index].queries, function (n) {
                  return n.query == "";
                });
                this.addQueryToRemove[index] =
                  convertedXml2[0].Configuration.ToRemove[0].Item[
                    index
                  ].Queries[0].Query.length;
              }
            }
          }
        }
        this.addDivRemove =
          convertedXml2[0].Configuration.ToRemove[0].Item.length;
      } catch (err) {}

      this.$forceUpdate();
    },
    semicolonKey: function (event) {
      if (event.key != undefined) {
        if (event.keyCode == 32) {
          this.SourceUrl.c_u_Keywords = `${this.SourceUrl.c_u_Keywords.replace(
            /\s/g,
            ""
          )};`;
        }
      }
    },
    resetFields() {
      this.clicked = 0;
      (this.sourceToEdit = []),
        (this.addDivTitle = 1),
        (this.addDivResume = 1),
        (this.addDivImage = 1),
        (this.addDivText = 1),
        (this.addDivRemove = 1),
        (this.addDivPartialUrl = 1),
        (this.addDivNotFullUrl = [false]),
        (this.addDivToRemoveQueries = [false]),
        (this.addDivToQueryOfRemove = [1]),
        (this.addDivToQuery = [1]),
        (this.addDivToRemove = 1),
        (this.optionsForRemoveUrl = []),
        (this.selectedUrlForRemove = [[]]),
        (this.addQueryToRemove = [1]);
      (this.optionsForUrl = []),
        (this.selectedUrlForExtract = []),
        (this.isSimple = true),
        (this.isSimple2 = true),
        (this.advancedXML = ""),
        (this.advancedXML2 = ""),
        (this.urlArray = [
          {
            url: "",
            priority: 0,
          },
        ]),
        (this.toReplaceOptions = [
          {
            toReplace: "",
            queryToReplace: [
              {
                query: "",
                toReplace: "",
                prepateQs: false,
                isPartial: false,
              },
            ],
            urlToReplace: "",
          },
        ]),
        (this.toRemoveOptions = [
          {
            queryToRemove: [
              {
                query: "",
                toReplace: "",
                prepateQs: false,
                isRemoved: false,
              },
            ],
            urlToRemove: "",
          },
        ]);
      (this.titleArray = [
        {
          query: "",
          confidenceLevel: 0,
        },
      ]),
        (this.resumeArray = [
          {
            query: "",
            confidenceLevel: 0,
          },
        ]),
        (this.imageArray = [
          {
            query: "",
            confidenceLevel: 0,
            isPartial: 0,
            toReplace: "",
          },
        ]),
        (this.imageArrayUrl = ""),
        (this.textArray = [
          {
            query: "",
            confidenceLevel: 0,
          },
        ]),
        (this.removeArray = [
          {
            reference: 0,
            queries: [{ query: "" }],
          },
        ]);
      this.$forceUpdate();
    },
    createXml2(evt) {
      if (this.isSimple2) {
        const xml = require("xml");
        let xml2 = [
          {
            Configuration: [
              { _attr: { For: "News" } },
              { URLs: "" },
              {
                ToExtract: [
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "title" } },
                      { Queries: [] },
                      { URL: [] },
                    ],
                  },
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "resume" } },
                      { Queries: [] },
                      { URL: [] },
                    ],
                  },
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "image" } },
                      { Queries: [] },
                      { URL: [] },
                    ],
                  },
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "text" } },
                      { Queries: [] },
                      { URL: [] },
                    ],
                  },
                ],
              },
              { ToRemove: [] },
            ],
          },
        ];

        //for loop to create the queries of title in the xml
        for (var index = 0; index < this.titleArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[0].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.titleArray[index].confidenceLevel,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace:
                    this.editedConvertedXML2[0].Configuration.ToExtract[0]
                      .Item[0].Queries[0].Query[index] != undefined
                      ? this.editedConvertedXML2[0].Configuration.ToExtract[0]
                          .Item[0].Queries[0].Query[index].$.ToReplace
                      : "",
                  PrepareTextForQS: "false",
                },
              },
              this.titleArray[index].query,
            ],
          });
        }

        xml2[0].Configuration[2].ToExtract[0].Item[2].URL = this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[0].URL;
        //for loop to create the queries of resume in the xml
        for (var index = 0; index < this.resumeArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[1].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.resumeArray[index].confidenceLevel,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace:
                    this.editedConvertedXML2[0].Configuration.ToExtract[0]
                      .Item[1].Queries[0].Query[index] != undefined
                      ? this.editedConvertedXML2[0].Configuration.ToExtract[0]
                          .Item[1].Queries[0].Query[index].$.ToReplace
                      : "",
                  PrepareTextForQS: "false",
                },
              },
              this.resumeArray[index].query,
            ],
          });
        }
        xml2[0].Configuration[2].ToExtract[1].Item[2].URL = this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[1].URL;

        //for loop to create the queries of image in the xml
        for (var index = 0; index < this.imageArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[2].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.imageArray[index].confidenceLevel,
                  IsURL: "true",
                  IsFullURL:
                    this.imageArray[index].isPartial == "1" ? "false" : "true",
                  ToReplace:
                    this.imageArray[index].isPartial == "1"
                      ? this.imageArray[index].toReplace
                      : "",
                  PrepareTextForQS: "false",
                },
              },
              this.imageArray[index].query,
            ],
          });
          if (this.imageArray[index].isPartial == "1") {
            xml2[0].Configuration[2].ToExtract[2].Item[2].URL = this.imageArrayUrl;
          } else {
            xml2[0].Configuration[2].ToExtract[2].Item[2].URL = "";
          }
        }

        //for loop to create the queries of text in the xml
        for (var index = 0; index < this.textArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[3].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.textArray[index].confidenceLevel,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace:
                    this.editedConvertedXML2[0].Configuration.ToExtract[0]
                      .Item[3].Queries[0].Query[index] != undefined
                      ? this.editedConvertedXML2[0].Configuration.ToExtract[0]
                          .Item[3].Queries[0].Query[index].$.ToReplace
                      : "",
                  PrepareTextForQS: "false",
                },
              },
              this.textArray[index].query,
            ],
          });
        }
        xml2[0].Configuration[2].ToExtract[3].Item[2].URL = this.editedConvertedXML2[0].Configuration.ToExtract[0].Item[3].URL;
        // for loop to create the queries of remove in the xml
        for (var index = 0; index < this.removeArray.length; index++) {
          xml2[0].Configuration[3].ToRemove.push({
            Item: [
              {
                _attr: {
                  ForURLsId: "",
                  Reference: this.removeArray[index].reference,
                },
              },
              {
                Queries: [],
              },
            ],
          });
          for (let i = 0; i < this.removeArray[index].queries.length; i++) {
            xml2[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
              Query: [
                {
                  _attr: {
                    Id: i + 1,
                    ConfidenceLevel: 0,
                    IsURL: "false",
                    IsFullURL: "false",
                    ToReplace: "",
                    PrepareTextForQS: "false",
                  },
                },
                this.removeArray[index].queries[i].query,
              ],
            });
          }
          // remove if query its equal to ""
          _.remove(
            xml2[0].Configuration[3].ToRemove[index].Item[1].Queries,
            function (n) {
              return n.Query[1] == "";
            }
          );
        }
        if (evt == undefined) {
          this.SourceUrl.c_u_Parameters2 = xml(xml2, {
            declaration: { version: "1.0", encoding: "UTF-8" },
            indent: true,
          });
        } else {
          this.SourceUrl.c_u_Parameters2 = xml(xml2, {
            declaration: { version: "1.0", encoding: "UTF-8" },
          });
        }
      } else {
        this.SourceUrl.c_u_Parameters2 = this.advancedXML2;
      }
      this.$emit(
        "ok",
        this.SourceUrl.c_u_Parameters1,
        this.SourceUrl.c_u_Parameters2
      );
    },
    async createUrlSouce(evt) {
      if (this.isSimple) {
        // create the xml for the source
        const xml = require("xml");
        let indexUrls = [];
        let queryIndex = 1;
        let xml1 = [
          {
            Configuration: [
              { _attr: { For: "List" } },
              { URLs: [] },
              { ToExtract: [] },
              { ToRemove: [] },
            ],
          },
        ];
        let newArrayOfToExtract = [];
        let stringOfUrls = "";
        for (
          var index = 0;
          index < this.selectedUrlForExtract.length;
          index++
        ) {
          for (let i = 0; i < this.selectedUrlForExtract[index].length; i++) {
            this.selectedUrlForExtract[index][i] =
              this.selectedUrlForExtract[index][i] + 1;
          }
          this.selectedUrlForExtract[index].sort();
          stringOfUrls = this.selectedUrlForExtract[index].join(",");
          newArrayOfToExtract.push({
            stringForUrlsId: stringOfUrls,
            url: this.toReplaceOptions[index].urlToReplace,
            query: this.toReplaceOptions[index].queryToReplace,
          });
        }
        for (var index = 0; index < this.urlArray.length; index++) {
          xml1[0].Configuration[1].URLs.push({
            URL: [
              {
                _attr: {
                  Id: index + 1,
                  Priority: this.urlArray[index].priority,
                },
              },
              this.urlArray[index].url,
            ],
          });
          indexUrls[index] = index + 1;
        }
        //For to create the items part of xml in toExtract
        for (var index = 0; index < newArrayOfToExtract.length; index++) {
          xml1[0].Configuration[2].ToExtract.push({
            Item: [
              {
                _attr: {
                  ForURLsId: newArrayOfToExtract[index].stringForUrlsId,
                },
              },
              {
                Queries: [],
              },
              {
                URL: newArrayOfToExtract[index].url,
              },
            ],
          });
          //for to create the queries inside the items parts of xml in ToExtract
          for (let u = 0; u < newArrayOfToExtract[index].query.length; u++) {
            xml1[0].Configuration[2].ToExtract[index].Item[1].Queries.push({
              Query: [
                {
                  _attr: {
                    Id: u + 1,
                    ConfidenceLevel: "0",
                    IsURL: "true",
                    IsFullURL:
                      newArrayOfToExtract[index].query[u].isPartial == true
                        ? "false"
                        : "true",
                    ToReplace:
                      newArrayOfToExtract[index].query[u].toReplace != ""
                        ? newArrayOfToExtract[index].query[
                            u
                          ].toReplace.includes("#")
                          ? newArrayOfToExtract[index].query[u].toReplace
                          : "#" +
                            newArrayOfToExtract[index].query[u].toReplace +
                            "#"
                        : "",
                    PrepareTextForQS:
                      newArrayOfToExtract[index].query[u].prepateQs,
                  },
                },
                this.sourceToEdit.c_u_Type != 2
                  ? newArrayOfToExtract[index].query[u].query.includes("/@href")
                    ? newArrayOfToExtract[index].query[u].query
                    : newArrayOfToExtract[index].query[u].query + "/@href"
                  : newArrayOfToExtract[index].query[u].query,
              ],
            });
          }
        }
        // Block for the ToRemove
        let arrayToRemoveItems = [];
        let stringOfUrlsToRemove = "";
        // to create the toRemove Items with queries
        for (var index = 0; index < this.selectedUrlForRemove.length; index++) {
          if (this.selectedUrlForRemove[index].length >= 1) {
            for (let i = 0; i < this.selectedUrlForRemove[index].length; i++) {
              this.selectedUrlForRemove[index][i] =
                this.selectedUrlForRemove[index][i] + 1;
            }
            this.selectedUrlForRemove[index].sort();
            stringOfUrlsToRemove = this.selectedUrlForRemove[index].join(",");
            arrayToRemoveItems.push({
              stringForUrlsId: stringOfUrlsToRemove,
              url: this.toRemoveOptions[index].urlToRemove,
              query: this.toRemoveOptions[index].queryToRemove,
            });
          }
        }

        if (arrayToRemoveItems != []) {
          for (var index = 0; index < arrayToRemoveItems.length; index++) {
            xml1[0].Configuration[3].ToRemove.push({
              Item: [
                {
                  _attr: {
                    ForURLsId: arrayToRemoveItems[index].stringForUrlsId,
                  },
                },
                {
                  Queries: [],
                },
                {
                  URL: arrayToRemoveItems[index].url,
                },
              ],
            });

            for (let u = 0; u < arrayToRemoveItems[index].query.length; u++) {
              xml1[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
                Query: [
                  {
                    _attr: {
                      Id: u + 1,
                      ConfidenceLevel: "0",
                      IsURL: "true",
                      IsFullURL:
                        arrayToRemoveItems[index].query[u].isRemoved == true
                          ? "false"
                          : "true",
                      ToReplace:
                        arrayToRemoveItems[index].query[u].toReplace != ""
                          ? arrayToRemoveItems[index].query[
                              u
                            ].toReplace.includes("#")
                            ? arrayToRemoveItems[index].query[u].toReplace
                            : "#" +
                              arrayToRemoveItems[index].query[u].toReplace +
                              "#"
                          : "",
                      PrepareTextForQS:
                        arrayToRemoveItems[index].query[u].prepateQs,
                    },
                  },
                  this.sourceToEdit.c_u_Type != 2
                    ? arrayToRemoveItems[index].query[u].query.includes(
                        "/@href"
                      )
                      ? arrayToRemoveItems[index].query[u].query
                      : arrayToRemoveItems[index].query[u].query + "/@href"
                    : arrayToRemoveItems[index].query[u].query,
                ],
              });
            }
          }
        }

        if (evt == undefined) {
          this.SourceUrl.c_u_Parameters1 = xml(xml1, {
            declaration: { version: "1.0", encoding: "UTF-8" },
            indent: true,
          });
        } else {
          this.SourceUrl.c_u_Parameters1 = xml(xml1, {
            declaration: { version: "1.0", encoding: "UTF-8" },
          });
        }
      } else {
        this.SourceUrl.c_u_Parameters1 = this.advancedXML;
      }
      // call the api
      // if(evt != undefined){
      //   await this.$api.data.updatedById(this.sourceToEdit.c_id, this.SourceUrl);
      this.$emit(
        "ok",
        this.SourceUrl.c_u_Parameters1,
        this.SourceUrl.c_u_Parameters2
      );

      //}
    },
    addPartialUrlDiv(evt) {
      this.addDivPartialUrl++;
      if (this.toReplaceOptions[this.addDivPartialUrl - 1] == undefined) {
        this.toReplaceOptions[this.addDivPartialUrl - 1] = {
          toReplace: "",
          queryToReplace: [],
          urlToReplace: "",
        };
        this.toReplaceOptions[this.addDivPartialUrl - 1].queryToReplace[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false,
        };
        this.addDivToQuery[this.addDivPartialUrl - 1] = 1;
      }
      this.$forceUpdate();
    },
    addQueryForUrl(evt, item) {
      this.addDivToQuery[item - 1]++;
      this.toReplaceOptions[item - 1].queryToReplace[
        this.addDivToQuery[item - 1] - 1
      ] = { query: "", toReplace: "", prepateQs: false, isPartial: false };
      this.$forceUpdate();
    },
    addQueryForRemove(evt, item) {
      this.addDivToQueryOfRemove[item - 1]++;
      this.toRemoveOptions[item - 1].queryToRemove[
        this.addDivToQueryOfRemove[item - 1] - 1
      ] = { query: "", toReplace: "", prepateQs: false, isRemoved: false };
      this.$forceUpdate();
    },
    toRemoveAddQueries(item) {
      if (this.addDivToRemoveQueries[item - 1] == undefined) {
        this.addDivToRemoveQueries[item - 1] = false;
        this.addDivToQueryOfRemove[item - 1] = 1;
      }
      this.$forceUpdate();
    },
    addDivForItemToRemove() {
      this.addDivToRemove++;
      if (this.toRemoveOptions[this.addDivToRemove - 1] == undefined) {
        this.toRemoveOptions[this.addDivToRemove - 1] = {
          toReplace: "",
          queryToRemove: [],
          urlToReplace: "",
        };
        this.toRemoveOptions[this.addDivToRemove - 1].queryToRemove[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false,
        };
        this.$forceUpdate();
      }
    },
    addTitleDiv(evt) {
      this.addDivTitle++;
      this.titleArray[this.addDivTitle - 1] = { query: "", confidenceLevel: 0 };
    },
    addResumeDiv(evt) {
      this.addDivResume++;
      this.resumeArray[this.addDivResume - 1] = {
        query: "",
        confidenceLevel: 0,
      };
    },
    addImageDiv(evt) {
      this.addDivImage++;
      this.imageArray[this.addDivImage - 1] = {
        query: "",
        confidenceLevel: 0,
        isPartial: 0,
        toReplace: "",
      };
    },
    addTextDiv(evt) {
      this.addDivText++;
      this.textArray[this.addDivText - 1] = { query: "", confidenceLevel: 0 };
    },
    addUrlDiv(evt) {
      this.clicked++;
      this.optionsForUrl.push({
        item: this.clicked - 1,
        name: `URL${this.clicked}`,
      });
      this.urlArray[this.clicked - 1] = { url: "", priority: 0 };
      this.$forceUpdate();
    },
    removeUrlDiv(evt) {
      this.urlArray.splice(evt, 1);
      this.optionsForUrl.splice(evt, 1);
      // for to remove the url if its already selected
      for (var index = 0; index < this.selectedUrlForExtract.length; index++) {
        _.remove(this.selectedUrlForExtract[index], function (id) {
          return id == evt;
        });
      }
      this.clicked--;
    },
    removeTitleDiv(evt) {
      this.titleArray.splice(evt, 1);
      this.addDivTitle--;
    },
    removeResumeDiv(evt) {
      this.resumeArray.splice(evt, 1);
      this.addDivResume--;
    },
    removeImageDiv(evt) {
      if (this.imageArray[evt].isPartial == "1") {
        this.imageArrayUrl = "";
      }
      this.imageArray.splice(evt, 1);
      this.addDivImage--;
    },
    removeTextDiv(evt) {
      this.textArray.splice(evt, 1);
      this.addDivText--;
    },
    removeItemfromUrl(item) {
      this.addDivPartialUrl--;
      this.selectedUrlForExtract.splice(item, 1);
      this.toReplaceOptions.splice(item, 1);
      this.addDivToQuery.splice(item, 1);
      this.addDivNotFullUrl.splice(item, 1);
      this.$forceUpdate();
    },
    removeItemOfRemove(item) {
      this.addDivToRemove--;
      this.addDivToRemoveQueries.splice(item, 1);
      this.selectedUrlForRemove.splice(item, 1);
      this.toRemoveOptions.splice(item, 1);
      this.$forceUpdate();
    },
    removeRemoveQueryUrl(item, query) {
      this.toRemoveOptions[item].queryToRemove.splice(query, 1);
      this.addDivToQueryOfRemove[item]--;
      this.$forceUpdate();
    },
    removeQueryOfUrl(item, query) {
      this.toReplaceOptions[item].queryToReplace.splice(query, 1);
      this.addDivToQuery[item]--;
      this.$forceUpdate();
    },
    removeRemoveQueries(item, query) {
      this.removeArray[item].queries.splice(query, 1);
      this.addQueryToRemove[item]--;
      this.$forceUpdate();
    },
    removeRemoveDiv(evt) {
      this.removeArray.splice(evt, 1);
      this.addDivRemove--;
    },
    addRemoveDiv(evt) {
      this.addDivRemove++;
      this.removeArray[this.addDivRemove - 1] = {
        reference: 0,
        queries: [{ query: "" }],
      };
      this.addQueryToRemove[this.addDivRemove - 1] = 1;
    },
    addRemoveDivQuery(evt, item) {
      this.addQueryToRemove[item - 1]++;
      this.removeArray[item - 1].queries[
        this.addQueryToRemove[item - 1] - 1
      ] = { query: "" };
      this.$forceUpdate();
    },
    advancedMode(evt) {
      if (this.isSimple == true) {
        this.createUrlSouce();
        this.advancedXML = this.SourceUrl.c_u_Parameters1;
        document.getElementsByClassName("advance")[0].innerText = "Simple Mode";
        this.isSimple = false;
      } else {
        document.getElementsByClassName("advance")[0].innerText =
          "Advanced Mode";
        this.isSimple = true;
      }
    },
    advancedMode2(evt) {
      if (this.isSimple2 == true) {
        this.createXml2();
        this.advancedXML2 = this.SourceUrl.c_u_Parameters2;

        document.getElementsByClassName("advance2")[0].innerText =
          "Simple Mode";
        this.isSimple2 = false;
      } else {
        document.getElementsByClassName("advance2")[0].innerText =
          "Advanced Mode";
        this.isSimple2 = true;
      }
    },
  },

  mounted: function () {},
};
</script>
<style scoped>
.borderStyler {
  border-top: 2px dashed #ecebea;
}
.queryBorder:nth-of-type(n + 2) {
  border-top: 2px dashed #ecebea;
}
.borderItem {
  margin-top: 5px;
  border-top: 5px solid #ecebea;
}
</style>



// WEBPACK FOOTER //
// src/components/Sources/EditUrl.vue